module.exports = __webpack_public_path__ + "img/dz01.1c3c958a.png";